import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-modal-status-icon',
  templateUrl: './modal-status-icon.component.html',
  styleUrls: ['./modal-status-icon.component.scss']
})
export class ModalStatusIconComponent implements OnInit {
  
  @Input() displayIcon: boolean;  
  @Input() type: string; // check / send
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/modal-status-icon/modal-status-icon.component.ts